import { render, staticRenderFns } from "./UserExamResults.vue?vue&type=template&id=1ae074c9&"
import script from "./UserExamResults.vue?vue&type=script&lang=ts&"
export * from "./UserExamResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports